// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__30rn-","itemTitle":"ClientEmergencyInfo_itemTitle__374EX","itemText":"ClientEmergencyInfo_itemText__106VG"};